export default {
  'Custom': 'Özel',
  'Original': 'Orijinal',
  'Resolution': 'Çözünürlük',
  'Frame rate': 'Kare hızı',
  'The higher the frame rate, the smoother the animation': 'Daha yüksek kare hızı, pürüzsüz animasyon.',
  'Start': 'Başlat',
  'End': 'Son',
  'Create GIF': 'GIF oluştur',
  'Download GIF': 'GIF indir',
  'Create A New One': 'Yeni Bir Tane Oluştur',
  'Remake GIF': 'Yeniden GIF Yap',
  'HitPaw Video to GIF Online': "HitPaw Çevrimiçi Video'dan GIF'e",
  'Upload and convert video to GIF without any difficulty': "Herhangi bir zorluk yaşamadan videoyu GIF'e yükleyin ve dönüştürün",
}